import Api from './Api'

export default {
    get(keyword, pageNumber, pageSize, order, idCategory) {
        return Api().get(`aulas?keyword=${keyword}&pageNumber=${pageNumber}&pageSize=${pageSize}&orderColumn=${order.column}&orderSort=${order.sort}&idCategory=${idCategory}`);
    },
    getOne(id) {
        return Api().get(`aulas/${id}`);
    },
    update(idNotification){
        return Api().put('aulas/update/visualizado', idNotification);
    },
    setAulaConcluida(idAula){
        return Api().post('aulas/complited', idAula);
    },
    getAllAulasAssistidas() {
        return Api().post(`aulas/assistidas`);
    }
}